import { render } from "./CollectInfoConfirm.vue?vue&type=template&id=0ead9f7c&scoped=true&ts=true"
import script from "./CollectInfoConfirm.vue?vue&type=script&lang=ts"
export * from "./CollectInfoConfirm.vue?vue&type=script&lang=ts"

import "./CollectInfoConfirm.vue?vue&type=style&index=0&id=0ead9f7c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ead9f7c"]])

export default __exports__